const glass = "_glass_sepwu_8";
const styles = {
  glass
};
export {
  styles as default,
  glass
};
//# sourceMappingURL=Glass.module.css.js.map
